'use client'

import ArticleHeader from '@/components/ArticleHeader'
import VideoPlayer from '@/components/VideoPlayer'
import { urlForImage } from '@/sanity/lib/image'
import { PortableText } from '@portabletext/react'
import Image from 'next/image'
import Link from 'next/link'
import { Fragment } from 'react'

interface ArticleContentProps {
	article: any
}

export default function ArticleContentPictures({ article }: ArticleContentProps) {
	const ArticleContentComponents = {
		// types: {
		// 	image: ({value}) => (
		// 		<div className={`article-image md:hidden w-full my-[6rem]`}>
		// 			<Image
		// 				className={`w-full h-auto md:h-full md:object-contain md:object-top`}
		// 				src={urlForImage(value).url()}
		// 				width={value?.asset?.metadata?.dimensions?.width}
		// 				height={value?.asset?.metadata?.dimensions?.height}
		// 				sizes="(min-width: 712px) 40vw, 100vw"
		// 				alt={value?.alt || ''}
		// 				placeholder="blur"
		// 				blurDataURL={value?.asset?.metadata?.lqip}
		// 			/>
		// 			{value?.caption && <p className="style-caption mt-6">{value?.caption}</p>}
		// 		</div>
		// 	),
		// },
		block: {
			h2: ({ children }: any) => (
				<h2 className="style-body--xl md:text-center mt-[4rem] md:mt-[6rem] mb-[3rem] md:mb-[5rem]">{children}</h2>
			),
			normal: ({ children }: any) => <p className="style-body mb-6">{children}</p>,
			blockquote: ({ children }: any) => <blockquote className="blockquote">{children}</blockquote>
		},
		marks: {
			link: ({ children, value }: any) => {
				const target = !value?.url?.startsWith('/') ? '_blank' : '_self'
				const rel = !value?.url?.startsWith('/') ? 'noreferrer noopener' : ''
				return target === '_blank' ? (
					<a href={value?.url} className="text-current hover:text-blue" rel={rel} target={target}>
						{children}
					</a>
				) : (
					<Link href={value?.url} className="text-current hover:text-blue" rel={rel} target={target}>
						{children}
					</Link>
				)
			}
		}
	}

	return (
		<div className={`relative`}>
			<div className={`site-grid mb-[6rem]`}>
				<div className={`col-span-full sm:col-span-10 sm:col-start-2 md:col-span-6 md:col-start-4`}>
					<ArticleHeader className="" title={article?.title} excerpt={article?.excerpt} />
				</div>
			</div>

			{article?.picturesContent?.map((block, index) => {
				console.log('block:', block)

				return (
					<Fragment key={`item-${block?._key}-${index}`}>
						{block?._type === 'pictureText' && (
							<div className={`site-grid my-[6rem] md:my-[10rem]`}>
								<div
									className={`col-span-full sm:col-span-8 md:col-span-6 ${block?.layout === 'right' && 'sm:col-start-5 md:col-start-7'} rich--text-content`}>
									<PortableText value={block?.text} components={ArticleContentComponents} />
								</div>
							</div>
						)}

						{block?._type === 'pictureImage' && (
							<div className={`site-grid my-[6rem] md:my-[10rem]`}>
								<div
									className={`col-span-full rounded-weak overflow-hidden ${['left', 'right'].includes(block?.layout) ? 'sm:col-span-8 md:col-span-6' : 'md:col-span-10 md:col-start-2'} ${block?.layout === 'right' && 'sm:col-start-5 md:col-start-7'}`}>
									<Image
										className={`w-full h-auto`}
										src={urlForImage(block?.image).url()}
										width={block?.image?.asset?.metadata?.dimensions?.width}
										height={block?.image?.asset?.metadata?.dimensions?.height}
										sizes={
											['left', 'right'].includes(block?.layout)
												? '(min-width: 1112px) 50vw, (min-width: 712px) 75vw, 100vw'
												: '(min-width: 1112px) 84vw, 100vw'
										}
										alt={block?.image?.alt || ''}
										placeholder="blur"
										blurDataURL={block?.image?.asset?.metadata?.lqip}
									/>
									{block?.image?.caption && <p className="style-caption mt-6">{block?.image?.caption}</p>}
								</div>
							</div>
						)}

						{block?._type === 'pictureVideo' && (
							<div className={`site-grid my-[6rem] md:my-[10rem]`}>
								<div
									className={`col-span-full rounded-weak overflow-hidden ${['left', 'right'].includes(block?.layout) ? 'sm:col-span-8 md:col-span-6' : 'md:col-span-10 md:col-start-2'} ${block?.layout === 'right' && 'sm:col-start-5 md:col-start-7'}`}>
									<VideoPlayer
										playbackId={block?.video?.asset?.playbackId}
										className={`block w-full h-auto`}
										autoplay={block?.autoplay}
										showAudioToggle={block?.showAudioToggle}
										loop={block?.loop}
										posterTime={block?.posterTime}
									/>
								</div>
							</div>
						)}
					</Fragment>
				)
			})}
		</div>
	)
}
